@use 'sass:meta';
@use '../../styles/fonts';
@use '../../styles/colors';
@use '../Button/Button.scss' as btn;
@use 'filter-bar-react-select' as reactSelect;

@mixin sizedFilterBar($container-height, $text-mixin, $help-icon-size, $gap) {
  height: $container-height;

  .filter-bar-component {
    .filter-bar-select__indicators {
      height: $container-height;
    }

    .filter-bar-select__control {
      height: $container-height;

      .filter-bar-select__value-container {
        height: ($container-height - (2 * btn.$BorderWidth));

        @include meta.apply($text-mixin);

        .filter-bar-select__placeholder {
          height: auto;

          @include meta.apply($text-mixin);

          color: colors.$Neutral500;

          * {
            @include meta.apply($text-mixin);
          }
        }
      }

      .filter-bar-select__indicators {
        height: ($container-height - (2 * btn.$BorderWidth));
      }
    }

    // Reserve space on the right so the absolutely-positioned help icon doesn't overlap text.
    &:has(.filter-bar-help) .filter-bar-select__control {
      padding-right: $help-icon-size + (2 * $gap);
    }

    .filter-bar-help {
      height: $container-height;

      .filter-bar-help-icon {
        width: $help-icon-size;
        height: $help-icon-size;
        margin: -($help-icon-size + $gap);
      }
    }
  }
}

// =============================================================
// Base layout — applies to every size.
// When using the CreatableSelect Component, the classes are filter-bar-select__<comp_type>.
// =============================================================
.filter-bar-component-container {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;

  &.auto-width {
    flex: 1;
    width: 100%;
  }

  // --- Advanced/Basic toggle (rendered when hasAdvanced=true) ---
  .segmented-control {
    z-index: 11;
    display: flex;
    align-items: center;

    .segmented-item:last-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-width: 0;
    }
  }

  // --- Input area (react-select overrides live in the partial) ---
  .filter-bar-component {
    z-index: 12;
    display: flex;
    flex: 1;
    min-width: 0;

    .filter-bar-select-container {
      display: flex;
      flex-grow: 1;
      min-width: 0;
    }

    @include reactSelect.reactSelectOverrides(btn.$BorderWidth);
  }

  // --- Help icon overlay (advanced mode only) ---
  .filter-bar-component:has(.filter-bar-help) {
    display: flex;
    align-items: flex-start;

    .filter-bar-help {
      z-index: 13;
      display: flex;
      align-items: center;

      .filter-bar-help-icon {
        color: colors.$Brand50;
      }

      .filter-bar-help-icon:hover {
        color: colors.$Brand80;
      }
    }
  }

  // --- Adjustments when the segmented-control toggle is a sibling ---
  .segmented-control ~ .filter-bar-component {
    .filter-bar-select__control {
      border-left: btn.$BorderWidth solid transparent;
      border-radius: 0 !important;
    }
  }

  .segmented-control.basic-on ~ .filter-bar-component {
    z-index: 10;
  }

  .segmented-control:has(.bpm-btn:not(.selected):nth-child(2):hover) ~ .filter-bar-component {
    z-index: 10;
  }
}

// =============================================================
// Widget styling (formerly the WIDGET variant — now the only shape)
// =============================================================

.filter-bar-component-container {
  .filter-bar-component {
    .filter-bar-select__control {
      border: 1px solid colors.$Neutral400;
      border-radius: 4px 0 0 4px;
      border-right-width: 0;

      .filter-bar-select__placeholder {
        color: colors.$Neutral500;
      }
    }

    .filter-bar-select__control:focus-within {
      border: 1px solid colors.$Brand50;
      border-right-width: 0;

      @include fonts.body;

      .filter-bar-select__placeholder {
        @include fonts.body;

        color: colors.$Brand100;
      }
    }
  }

  .segmented-control ~ .filter-bar-component {
    .filter-bar-select__control {
      border-left-width: 0;
    }
  }

  .filter-submit {
    z-index: 12;
    border-radius: 0 6px 6px 0;
  }
}

// =============================================================
// Sizes
// =============================================================

.filter-bar-component-container.small {
  @include sizedFilterBar(
    btn.$SmContainerHeight,
    meta.get-mixin('tertiary', $module: fonts),
    14px,
    btn.$SmGap
  );
}

.filter-bar-component-container.medium {
  @include sizedFilterBar(
    btn.$MdContainerHeight,
    meta.get-mixin('secondary', $module: fonts),
    18px,
    btn.$MdGap
  );
}

.filter-bar-component-container.large {
  @include sizedFilterBar(
    btn.$LgContainerHeight,
    meta.get-mixin('body', $module: fonts),
    22px,
    btn.$LgGap
  );
}
